import combineReducers from 'react-combine-reducers';
import auth from './auth';
// import user from './user';

const [reducer, initialState] = combineReducers({
    auth,
    // user,
});

export { reducer, initialState };
